import * as ActionTypes from '../../actions/allActions'

const affiliateMessagesFormInit = { message: "" }
const affiliateMessagesForm = (state = affiliateMessagesFormInit, action) => {
	switch(action.type){
		case ActionTypes.AFFILIATEMESSAGES_DATACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.SUBMITAFFILIATEMESSAGE_SUCCESS:
			return { ...state, message: "" }
		case ActionTypes.LOGOUT:
			return affiliateMessagesFormInit
		default:
			return state
	}
}

export default affiliateMessagesForm


// WEBPACK FOOTER //
// ./src/reducers/data/affiliateMessagesForm.js